import { useTranslation } from 'react-i18next';
import { ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { usePartnerAgencyBusinessAssociatesQuery } from '@anytag/graphql';
import {
  AssociatedAccountsList,
  AssociatedAccountsFilter,
  useAssociatedAccountsFilter
} from '@anytag/shared-organisms';

export interface PartnerAssociatedAccountsProps {
  partnerId: number;
}

export const PartnerAssociatedAccounts = ({ partnerId }: PartnerAssociatedAccountsProps) => {
  const { t } = useTranslation();
  const { page, limit, filter } = useAssociatedAccountsFilter();
  const { data, previousData, loading } = usePartnerAgencyBusinessAssociatesQuery({
    fetchPolicy: 'network-only',
    variables: getValuableVariables({ limit, partnerAgencyId: partnerId, offset: getOffset(page, limit), ...filter })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.partnerAgencyBusinessAssociatesCount?.totalNumber || 0;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <AssociatedAccountsFilter keywordPlaceholder={t<string>('Search.Search by Company Name')} />
      <AssociatedAccountsList
        loading={loading}
        data={result?.partnerAgencyBusinessAssociates || []}
        refetchQueries={['PartnerAgencyBusinessAssociateCompanies']}
      />
    </ListWithPagination>
  );
};
